import { useCallback, useEffect } from 'react';

export const useParentHoverControl = (
  onHoverStateChange?: (shouldDisable: boolean) => void
) => {
  const disableParentHover = useCallback(() => {
    onHoverStateChange?.(true);
  }, [onHoverStateChange]);

  const enableParentHover = useCallback(() => {
    onHoverStateChange?.(false);
  }, [onHoverStateChange]);

  return {
    disableParentHover,
    enableParentHover,
  };
};

export const useEditingHoverControl = (
  onHoverStateChange?: (shouldDisable: boolean) => void
) => {
  const { disableParentHover, enableParentHover } =
    useParentHoverControl(onHoverStateChange);

  const handleStartEditing = useCallback(() => {
    disableParentHover();
  }, [disableParentHover]);

  const handleStopEditing = useCallback(() => {
    enableParentHover();
  }, [enableParentHover]);

  return {
    handleStartEditing,
    handleStopEditing,
    disableParentHover,
    enableParentHover,
  };
};

export const useAutoHoverControl = (
  isActive: boolean,
  onHoverStateChange?: (shouldDisable: boolean) => void
) => {
  const { disableParentHover, enableParentHover } =
    useParentHoverControl(onHoverStateChange);

  useEffect(() => {
    if (isActive) {
      disableParentHover();
    } else {
      enableParentHover();
    }
  }, [isActive, disableParentHover, enableParentHover]);

  return {
    disableParentHover,
    enableParentHover,
  };
};